import { render, staticRenderFns } from "./critical_asset.vue?vue&type=template&id=b4ed84bc&scoped=true"
import script from "./critical_asset.vue?vue&type=script&lang=js"
export * from "./critical_asset.vue?vue&type=script&lang=js"
import style0 from "./critical_asset.vue?vue&type=style&index=0&id=b4ed84bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed84bc",
  null
  
)

export default component.exports